module.exports = __webpack_public_path__ + "assets/img/teacher (10).8914b665.png";